import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import firebase from 'firebase/compat/app';
import SignInScreen from './auth/SignInScreen';

const firebaseConfig = {
  apiKey: "AIzaSyBlMIaEt8aKfDgsQQESapJDtglcyonWnK0",
  authDomain: "day-to-day-fantasy-nba.firebaseapp.com",
  databaseURL: "https://day-to-day-fantasy-nba-default-rtdb.firebaseio.com",
  projectId: "day-to-day-fantasy-nba",
  storageBucket: "day-to-day-fantasy-nba.appspot.com",
  messagingSenderId: "762297474526",
  appId: "1:762297474526:web:6643e99982b1c62f59114f",
  measurementId: "G-X94GNGXE4P"
};

firebase.initializeApp(firebaseConfig);

ReactDOM.render(<SignInScreen/>, document.getElementById('root'));
